import { Component, computed, DestroyRef, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { CustomUserDropdownItem } from '@galaxy/atlas';
import { AuthService } from './core/auth/auth.service';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';
import { Environment, EnvironmentService } from '@galaxy/core';
import { MatIconRegistry } from '@angular/material/icon';

const ENV_ORIGINS = {
  demo: 'https://admin-demo.vendasta-internal.com',
  prod: 'https://admin.vendasta-internal.com',
} as const;

function envReplacedUrl(url: string, env: keyof typeof ENV_ORIGINS): string {
  const currentOrigin = Object.values(ENV_ORIGINS).find((origin) => url.startsWith(origin));
  return currentOrigin ? url.replace(currentOrigin, ENV_ORIGINS[env]) : url;
}

@Component({
  selector: 'app-authed-app',
  templateUrl: './authed-app.component.html',
  styleUrls: ['./authed-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthedAppComponent implements OnInit {
  private authService = inject(AuthService);
  private aiIconService = inject(GalaxyAiIconService);
  private envService = inject(EnvironmentService);
  private location = inject(Location);
  private destroyRef = inject(DestroyRef);

  private currentUrl = signal(window.location.href);
  isDemo = this.envService.getEnvironment() === Environment.DEMO;
  demoUrl = computed(() => envReplacedUrl(this.currentUrl(), 'demo'));
  prodUrl = computed(() => envReplacedUrl(this.currentUrl(), 'prod'));

  constructor(private matIconReg: MatIconRegistry) {
    this.destroyRef.onDestroy(this.location.onUrlChange(() => this.currentUrl.set(window.location.href)));
  }

  ngOnInit(): void {
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }

  dropdownItems: CustomUserDropdownItem[] = [
    {
      label: 'Logout',
      callback: () => this.logout(),
    },
  ];

  logout(): void {
    this.authService.logout({ namespace: 'VA' });
  }
  getEnv(): string {
    return this.envService.getEnvironmentString();
  }
}
